/**
 * Get the formatted price of a number
 * @param {string} price - The number needed to be formatted (e.g., "1900").
 * @param {number} decimals - The number of decimals to display in the currency (e.g., "1,900" vs "1,900.00").
 * @returns {Object} - Format number to readable USD currency
 */

export const formatPrice = (price, decimals = 2) => {
  if (!price) return '-';

  const priceAsNumber = Number(price);
  return priceAsNumber.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};
